import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { setupCellTooltip } from './utils/cellTooltip'
import { setUnauthorizedHandler } from './utils/request'
import request from './utils/request'
import type { AcsResult } from './api/types'
import { SITE_NAME } from './config/site'

setUnauthorizedHandler(() => {
  if (router.currentRoute.value.path !== '/login') {
    router.replace('/login')
  }
})

// 动态设置浏览器标签页标题和图标（跟随平台配置）
function applyFavicon(logoUrl?: string) {
  if (!logoUrl) return
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = logoUrl
}
const local = localStorage.getItem('admin.platform.defaults')
if (local) {
  try {
    const data = JSON.parse(local)
    if (data.platformName) document.title = String(data.platformName)
    if (data.logoUrl) applyFavicon(String(data.logoUrl))
  } catch { /* ignore */ }
}
request<AcsResult<Record<string, unknown>>>({
  url: '/system/config/getLogo',
  method: 'get',
}).then((res) => {
  const data = ((res as AcsResult<Record<string, unknown>>)?.data ?? {}) as Record<string, unknown>
  if (data.platformName) document.title = String(data.platformName)
  else document.title = SITE_NAME
  if (data.logoUrl) applyFavicon(String(data.logoUrl))
  if (Object.keys(data).length) {
    localStorage.setItem('admin.platform.defaults', JSON.stringify(data))
  }
}).catch(() => { document.title = SITE_NAME })

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')

// 全局表格单元格溢出 tooltip
setupCellTooltip()
